/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 12.05.2016.
 */

import React, {Component, PropTypes} from 'react';
import {FacebookButton, TwitterButton} from "react-social";

import Translate from '../../../../Translate';
  
class Share extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  /**
   * TODO: url, title, description, picture
   */
  render() {

    return (
      <div>
        <div className="color-grey pv-"><Translate content="profile.movie.share" /></div>
        <div className="social-links-ott">
          <div className="social-link-ott hover pr">
            <FacebookButton url={this.props.contentUrl} element="span" appId="318783521795926">
              <i className="ic ic-fb ic-24px"></i>
            </FacebookButton>
          </div>
          <div className="social-link-ott hover">
            <TwitterButton url={this.props.contentUrl} element="span">
              <i className="ic ic-tw ic-24px"></i>
            </TwitterButton>
          </div>
        </div>
      </div>
    );
  }
}

Share.propTypes = {
  contentUrl: PropTypes.string.isRequired
};

Share.defaultProps = {
  contentUrl: location.origin
};

export default Share;


// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Widgets/Share/share.js